import { RestClient } from '@/api/rest-client'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import { cloneDeep, isEmpty } from 'lodash'
import { Company } from '@/api/model/company'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { RealworksCredentials } from '@/api/model/credentials'
import { Pipeline } from '@/api/model/pipeline'
import { Source } from '@/api/model/source'

export class TriggeredReferralClient extends RestClient<TriggeredReferral> {
    collectionName = 'triggered_referrals'
    parseData = TriggeredReferral.fromData

    async create(data: TriggeredReferral): Promise<TriggeredReferral> {
        const request = cloneDeep<any>(data)

        request.realworksKenmerkId = data.realworksKenmerkId ? data.realworksKenmerkId.toString() : null

        if (isEmpty(data.referralComment)) {
            request.referralComment = ''
        }

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.realworksCredentials instanceof RealworksCredentials) {
            request.realworksCredentials = data.realworksCredentials.resourceIdentifier
        }

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        if (data.referralAssignedToBranch instanceof Branch) {
            request.referralAssignedToBranch = data.referralAssignedToBranch.resourceIdentifier
        }

        if (data.referralAssignedTo instanceof User) {
            request.referralAssignedTo = data.referralAssignedTo.resourceIdentifier
        }

        if (data.referralReferredByBranch instanceof Branch) {
            request.referralReferredByBranch = data.referralReferredByBranch.resourceIdentifier
        }

        if (data.referralReferredBy instanceof User) {
            request.referralReferredBy = data.referralReferredBy.resourceIdentifier
        }

        if (data.referralNewSource instanceof Source) {
            request.referralNewSource = data.referralNewSource.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: TriggeredReferral): Promise<TriggeredReferral> {
        const request = cloneDeep<any>(data)

        request.realworksKenmerkId = data.realworksKenmerkId ? data.realworksKenmerkId.toString() : null

        if (isEmpty(data.referralComment)) {
            request.referralComment = ''
        }

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.realworksCredentials instanceof RealworksCredentials) {
            request.realworksCredentials = data.realworksCredentials.resourceIdentifier
        }

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        if (data.referralAssignedToBranch instanceof Branch) {
            request.referralAssignedToBranch = data.referralAssignedToBranch.resourceIdentifier
        }

        if (data.referralAssignedTo instanceof User) {
            request.referralAssignedTo = data.referralAssignedTo.resourceIdentifier
        }

        if (data.referralReferredByBranch instanceof Branch) {
            request.referralReferredByBranch = data.referralReferredByBranch.resourceIdentifier
        }

        if (data.referralReferredBy instanceof User) {
            request.referralReferredBy = data.referralReferredBy.resourceIdentifier
        }

        if (data.referralNewSource instanceof Source) {
            request.referralNewSource = data.referralNewSource.resourceIdentifier
        }

        return super.update(id, request)
    }
}
